// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._12ji1r31{outline-color:currentColor}\n._12y3idpf{outline-width:0}\n._1e0c1o8l{display:inline-block}\n._1qu2glyw{outline-style:none}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
